import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import CssBaseline from '@material-ui/core/CssBaseline'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Grid from '@material-ui/core/Grid'
import Logo from 'src/components/logo/index'
import URL from 'src/api/url'
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
const drawerWidth = 240
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    width: '100%',
  },
  listItems: {
    paddingBottom: '10px',
    '&:hover': {
      color: '#0d53b7',
    },
  },
  mainGrid: {
    width: '100%',
  },
}))

function Policies(props) {
  const classes = useStyles()
  const [selectedField, setSelectedField] = useState(
    'https://share.minicoursegenerator.com/legal-notice-and-terms-of-use-638303667306535193',
  )
  const [fieldName, setFieldName] = useState('')

  const changeFieldOnClick = e => {
    setFieldName(e.target.innerText)
    switch (e.target.innerText) {
      case 'Legal Notice and Terms of Use':
        setSelectedField(
          'https://share.minicoursegenerator.com/legal-notice-and-terms-of-use-638303667306535193',
        )
        break
      case 'Service Terms and Conditions':
        setSelectedField(
          'https://share.minicoursegenerator.com/service-terms-and-conditions-638303667609495266/1',
        )
        break
      case 'Privacy Policy':
        setSelectedField(
          'https://share.minicoursegenerator.com/privacy-policy-638303666384057395/1',
        )
        break

      case 'Data Processing Agreement':
        setSelectedField(
          'https://share.minicoursegenerator.com/data-processing-agreement-638303668687818594/1',
        )
        break
      case 'Cookies Policy':
        setSelectedField(
          'https://share.minicoursegenerator.com/cookies-policy-638303666612148916/1',
        )
        break
      case 'Payment Terms and Conditions':
        setSelectedField(
          'https://share.minicoursegenerator.com/payment-terms-and-conditions-638303666511376601',
        )
        break
      case 'Report Abuse':
        setSelectedField(
          'https://share.minicoursegenerator.com/report-abuse-638303666470810486/1',
        )
        break

      default:
        return null
    }
  }
  return (
    <Grid container>
      <div className={classes.root}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div style={{ paddingTop: '20px' }}>
            <Logo sx={{ height: 64 }} />
          </div>

          <div className={classes.drawerContainer}>
            <List>
              {[
                'Legal Notice and Terms of Use',
                'Service Terms and Conditions',
                'Privacy Policy',
                'Data Processing Agreement',
                'Cookies Policy',
                'Payment Terms and Conditions',
                'Report Abuse',
              ].map((text, index) => (
                <ListItem
                  className={classes.listItems}
                  button
                  key={text}
                  onClick={e => {
                    changeFieldOnClick(e)
                  }}
                >
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </div>
        </Drawer>
        <Grid className={classes.mainGrid}>
          <Toolbar />

          <iframe
            width={1100}
            height={900}
            style={{ border: '0' }}
            title="Legal Notice and Terms of Use"
            src={selectedField}
          ></iframe>
        </Grid>
      </div>
    </Grid>
  )
}

export default Policies
